class ColorWheel extends HTMLElement {
  constructor() {
    super();
    this.swiper;
    this.sectionId = this.dataset.sectionId;

  }

  connectedCallback() {
    this.initSwiper();
    this.initSliderViewButtons();
    this._initHelperOverlay();
  }
 

  initSwiper() {
    this.swiper = new Swiper('.swiper', {
      direction: 'horizontal',
      effect: 'coverflow',
      loop: false,
      slidesPerView: 3,
      spaceBetween: 5,
      centeredSlides: true,
      slideToClickedSlide: true,
      coverflowEffect: {
        rotate: 20,
        stretch: 0,
        depth: 100,
        modifier: 1,
        scale: 0.9,
        slideShadows: false,
      },
      pagination: {
        el: `.swiper-pagination--${this.sectionId}`,
        type: "progressbar",
      },
      breakpoints: {
        767: {
          slidesPerView: 4,
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.splide__arrow--next',
        prevEl: '.splide__arrow--prev',
      },
    });

    this.thumbnails = document.querySelectorAll('.product-gallery--media-thumbnail');
    this.thumbnails.forEach((image) => {
      if(!image.dataset.firstAvailableVariant == true) {
        image.style.display = 'none';
      }
    })

    this.swiper.on('transitionEnd', (event) => {
      this.swatchElement = document.querySelector(`#variant-swatch-${this.swiper.activeIndex}`);
      if (this.swatchElement) {
        this.swatchElement.click();
        this.colourValue = this.swatchElement.querySelector('input').value.replace(/\s/g, "").toLowerCase();
        this.toggleImages(this.colourValue);
      }
    });

    this.activeColor = document.querySelector('.variant-selection__variants option[selected]').dataset.title;
    this.activeSlideIndex = this.querySelector(`.options-selection__option-value-input[value="${this.activeColor}"]`).dataset.slideIndex;
    this.swiper.slideTo(this.activeSlideIndex, 10);
  }

  toggleImages(colourValue) {
    console.log(colourValue)
    this.thumbnails.forEach((image) => {
      this.imageFile = image.dataset.file.toLowerCase();
      if(!this.imageFile.includes(`${colourValue}`)) {
        image.style.display = 'none';
      } else {
        image.style.display = 'inline-block'
      }
    })
  }


  initSliderViewButtons() {
    this.gridView = document.querySelector('[data-grid-view]');
    this.sliderView = document.querySelector('[data-slider-view]');
    this.colours = document.querySelector(`#product-color-slider--${this.sectionId}`);
    this.variants = document.querySelector('variant-selection');
    this.variants.classList.remove('changing-layouts');

    this.gridView.addEventListener('click', () => {
      if(!this.gridView.classList.contains('active')) {
        this.variants.classList.add('changing-layouts');
        this.swiper.destroy(true, true);
        this.gridView.classList.add('active');
        this.sliderView.classList.remove('active');
        this.colours.classList.add('is-grid');
        setTimeout(() => {
          this.variants.classList.remove('changing-layouts');
        }, 1000)
        this.colorSwatches = document.querySelectorAll('.is-grid .options-selection__option-value');
        if(this.colorSwatches) {
          this.colorSwatches.forEach((swatch, index) => swatch.addEventListener('click', (event) => {
            this.colourValue = swatch.querySelector('input').value.replace(/\s/g, "").toLowerCase();
            this.toggleImages(this.colourValue);
            this.colorSwatches.forEach((swatch) => swatch.classList.remove('swiper-slide-active'))
            swatch.classList.add('swiper-slide-active');
          }));
        }
      }
    });

    this.sliderView.addEventListener('click', () => {
      if(!this.sliderView.classList.contains('active')) {
        this.variants.classList.add('changing-layouts');
        this.initSwiper();
        this.sliderView.classList.add('active');
        this.gridView.classList.remove('active');
        this.colours.classList.remove('is-grid');
        setTimeout(() => {
          this.variants.classList.remove('changing-layouts');
        }, 1000)
      }
    })
  }

  _initHelperOverlay() {
    this.helpLinks = document.querySelectorAll('[data-helper-link]');
    this.closeButton = document.querySelector('.kit-builder__helper--close');
    if(this.helpLinks) {
      this.helpLinks.forEach((link) => link.addEventListener('click', (event) => this._handleHelpLink(event, link)))
    }
    this.closeButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.helperOverlay.style.display = 'none';
      this.helperContent.display = 'none';
    })
  }

  _handleHelpLink(e, link) {
    e.preventDefault();
    let helpType = link.dataset.helperContent;
    this.helperOverlay = document.querySelector(`[data-color-helper]`);
    this.helperContent = document.querySelector(`[data-helper-text="${helpType}"]`);
    this.helperOverlay.style.display = 'flex';
    this.helperOverlay.style.opacity = '0';
    this.helperContent.style.display = 'block';
    setTimeout(() => {
      this.helperOverlay.style.opacity = '1';
    }, 500)
  }
};

if(!window.customElements.get('color-wheel')) {
  window.customElements.define('color-wheel', ColorWheel)
}